import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import {
  CreateMapIntegrationPlanModal,
  EditMapIntegrationPlanModal,
  MapIntegrationPlanListFilters
} from "@modules/mapIntegrationPlans/components";

import {  useMapIntegrationPlanList } from "./controller";
import { useMapIntegrationPlanListColumns } from "./columns";

export const MapIntegrationPlanList = React.memo(() => {
  const {
    rows,
    agreements,
    plans,
    loading,
    selectedRows,
    dataToExport,
    createMapIntegrationPlanModalRef,
    editMapIntegrationPlanModalRef,
    setSelectedRows,
    refetch,
    translate,
    tableProps
  } =  useMapIntegrationPlanList();

  const columns = useMapIntegrationPlanListColumns(
    refetch,
    translate,
    editMapIntegrationPlanModalRef,
    agreements,
    plans
  );

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <MapIntegrationPlanListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="mapintegrationplans.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton onClick={() => createMapIntegrationPlanModalRef.current?.open()} />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreateMapIntegrationPlanModal modalRef={createMapIntegrationPlanModalRef} />
      <EditMapIntegrationPlanModal modalRef={editMapIntegrationPlanModalRef} />
    </List>
  );
});
